import * as React from "react";
import {useEffect, useState} from "react";
import {IRepaymode} from "StateInterface";
import {Snackbar} from "web-com";
import {RePayMode} from "./repaymentOptions";

interface IProps {
    errorMsg: string;
    repaymentModes: IRepaymode[];
    onCloseHandler: () => void;
}
const matchingErrorMsg = "Bank not eligible for enach";
enum errorMessages  {
    SUPPORT = "Your bank is not eligible for E-NACH. Please contact us at support@myshubhlife.com",
    SCAN = "Your bank is not eligible for E-NACH. Please select Scan and Upload.",
}

const ErrorHandle = (props: IProps) => {
    const [error, setError] = useState<string>(null);
    useEffect(() => {
        const modes = props.repaymentModes.map((ele) => ele.mode);
        if (props.errorMsg.includes(matchingErrorMsg)) { 
            modes.includes(RePayMode[RePayMode.Scan]) ?
                setError(errorMessages.SCAN) : setError(errorMessages.SUPPORT);
        } else {
            setError(props.errorMsg);
        }
    }, [])
    
    return (
        <Snackbar 
            type="danger" 
            show={error} 
            onCloseHandler={props.onCloseHandler}
            timeout={props.errorMsg.length > 25 ? 12000 : 5000}
        >
            {error}
        </Snackbar>
    )
}

export default ErrorHandle;

